import Helper from '../../../src/Helper.js';
import './style.scss';
import '../../../src/docReady.js';
import Dom from '../../../src/Dom.js';
import isMobile from '../../../src/isMobile.js';
import './style.scss';

const moduleSelector = '.eiovisual-pcon';

/**
 * Classe esempio
 */
class Module {
    
    // _________________________________________________________________________
    
    constructor() {
        this.run();
        
        Helper.debug('Modulo pcon');
    }

    // _________________________________________________________________________
    
    /**
     * Run di questo block.
     * @returns this
     */
    run() {
        var that = this;

        docReady(() => {
            let $modules = document.querySelectorAll(moduleSelector);

            // avvia il carousel per ogni modulo trovato
            $modules.forEach(($module) => {
                new ModuleFeature($module);
            });
        });
    }
}

class ModuleFeature {

    constructor($module) {
        this.$module = $module;
        
        this.init_feature();
    }

    // _________________________________________________________________________

    init_feature() {
        
        // Tasks on images
        setTimeout(async () => { 
            
            new Promise(resolve => {
                this.task1();
            });
            
            await this.task2();
        },0); // abilita effetto scrollmagic
    }

    // _________________________________________________________________________

    /**
     * Sostituisce gli elementi .fit-text con elementi fit-text
     * @returns {undefined}
     */
    task1() {
        const $trigger = this.$module.querySelector('.pcon-trigger')

        // set trigger
        $trigger.addEventListener('click', (e) => {

            e.preventDefault()

            const rel = e.target.getAttribute('rel')

            document.querySelector('#' + rel).classList.add('active')
            document.body.style.overflow = 'hidden';
            document.body.style.width = '100vw';
            document.body.style.height = '100vh';
        })

        // set close
        const $close = document.querySelector('.pcon-close')

        $close.addEventListener('click', (e) => {
            e.preventDefault()

            const rel = e.target.getAttribute('rel')

            document.querySelector('#' + rel).classList.remove('active')
            document.body.style.overflow = 'auto';
            document.body.style.width = 'auto';
            document.body.style.height = 'auto';
        })
    }

    // _________________________________________________________________________

    /**
     * Abilità ingresso con scroll della scritta fit-text
     */
    task2() {
    }

    // _________________________________________________________________________

}

// export
export default new Module();